import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useApolloClient } from '@apollo/client';
import { Modal } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAuth } from 'react-oidc-context';
import { HandleLogout } from './handle-logout';

const idleTimerTimeout = parseInt(import.meta.env.VITE_IDLE_TIMER ?? '1500000'); // time in milliseconds before the user is prompted
const logoutTimeout = parseInt(import.meta.env.VITE_LOGOUT_TIMER ?? '1800000'); // time in milliseconds before the user is logged out, including the time to prompt the user

interface IdleTimerProps {
  children?: any;
  visible?: boolean; // this is declared as optional to support the storybook
  onOk?: () => void; // this is declared as optional to support the storybook
}

export const IdleTimer: FC<IdleTimerProps> = (props) => {
  const auth = useAuth();
  const client = useApolloClient();

  const [isPromptModalVisible, setIsPromptModalVisible] = useState(false);

  const onIdle = () => {
    // Close Modal Prompt
    setIsPromptModalVisible(false);
    Modal.destroyAll();
    HandleLogout(auth, client, window.location.origin);
  };

  const onPrompt = () => {
    setIsPromptModalVisible(true);
  };

  const onActive = () => {
    reset();
  };

  const { reset } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    timeout: logoutTimeout,
    promptBeforeIdle: logoutTimeout - idleTimerTimeout,
    name: 'main-idle-timer'
  });

  const onOk = () => {
    reset();
    setIsPromptModalVisible(false);
  };

  useEffect(() => {
    if (props.visible || isPromptModalVisible) {
      Modal.warning({
        content: `Are you still there?`,
        okText: 'Stay Logged In',
        icon: <ExclamationCircleOutlined />,
        okButtonProps: { style: { background: '#3f4373', outline: 0 } },
        onOk: props.onOk ?? onOk
      });
    }
  }, [isPromptModalVisible, props.visible]);

  return <>{props.children}</>;
};
